import { Plugin } from 'chart.js';

export const requiredStockLinePlugin: Plugin = {
  id: 'requiredStockLine',
  afterDatasetsDraw(chart) {
    const { ctx, scales, data } = chart;

    if (!data.datasets || data.datasets.length === 0) return;

    // Find the required stock dataset
    const requiredStockDataset = data.datasets.find((ds) =>
      ['Required coverage', 'Required Stock'].includes(ds.label || ''),
    );
    if (!requiredStockDataset || !requiredStockDataset.data) return;

    const xScale = scales.x;
    const yScale = scales.y;

    ctx.save();

    // Draw red lines for each data point
    requiredStockDataset.data.forEach((value: any, index: number) => {
      if (value === null || value === undefined) return;

      const x = xScale.getPixelForValue(index);
      const y = yScale.getPixelForValue(value);

      // Draw red horizontal line
      ctx.strokeStyle = '#EF4444'; // Red color
      ctx.lineWidth = 2;
      ctx.setLineDash([]);

      ctx.beginPath();
      ctx.moveTo(x - 20, y);
      ctx.lineTo(x + 20, y);
      ctx.stroke();
    });

    ctx.restore();
  },
};
